import Swiper from "swiper/bundle";

export const slider = () => {
  const swiper = new Swiper(".swiper-container", {
    loop: true,
    speed: 3000,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: ".mv__slide-pagination",
      type: "bullets",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
};
